<template>
  <div v-if="slotComponents.length" class="plugin-slot">
    <component
      :is="component"
      v-for="(component, index) in slotComponents"
      :key="`${name}-${index}`"
      v-bind="slotProps"
    />
  </div>
</template>

<script>
import pluginSlots from "@/_utils/pluginSlots";

export default {
  name: "PluginSlot",
  props: {
    name: {
      type: String,
      required: true,
    },
    slotProps: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    slotComponents() {
      return pluginSlots.get(this.name);
    },
  },
};
</script>
